import React from 'react';
import {
  IHeaderCardFragment,
  IAimGeneralOptionsQuery,
  IPostFragment,
} from '@orgnc/core/generated/graphql-operations';
import { useGlobalQuery } from '@orgnc/core/hooks';
import nonNullable from '@orgnc/core/lib/utils/types/nonNullable';
import aimGeneralOptionsQuery from '../lib/queries/aimGeneralOptionsQuery';

type IAimGeneralOptions = {
  headerCardsByColumn?: {
    left: IHeaderCardFragment[];
    right: IHeaderCardFragment[];
  };
  buyingGuideSpotlightPost?: IPostFragment;
};

export const useAimGeneralOptions = () => {
  const result: IAimGeneralOptions = {};
  const { data: aimGeneralOptions } = useGlobalQuery<IAimGeneralOptionsQuery>(
    aimGeneralOptionsQuery
  );

  const headerCardsByColumn = React.useMemo(() => {
    const cards =
      aimGeneralOptions?.flexpressCMSSettings?.generalOptions?.cards ??
      undefined;
    if (!cards?.showHeaderCards) {
      return undefined;
    }

    return cards?.headerCards?.filter(nonNullable).reduce(
      (acc, card) => {
        const column = card.side?.[0] === 'left' ? 'left' : 'right';

        return { ...acc, [column]: [...acc[column], card] };
      },
      { left: [] as IHeaderCardFragment[], right: [] as IHeaderCardFragment[] }
    );
  }, [aimGeneralOptions]);

  result.headerCardsByColumn = headerCardsByColumn;
  result.buyingGuideSpotlightPost = aimGeneralOptions?.flexpressCMSSettings
    ?.generalOptions?.aimGeneralOptions?.buyingGuideSpotlightPost
    ?.nodes[0] as IPostFragment;

  return result;
};
